<template>
    <div class="upgrade col-sm-6 col-xs-12">
        <b-card show-header class="mb-4" show-footer>
            <h3 slot="header">{{ upgrade.name | translate }}</h3>
            <div class="row">
                <div class="col-4 col-sm-12 col-md-4">
                    <div class="icon">
                        <i v-if="upgrade.faClass !== null" class="fa icon upgrade-font-icon" :class="upgrade.faClass"></i>
                    </div>
                </div>
                <div class="col-8 col-sm-12 col-md-8">
                    <p class="description">
                        {{ $t(upgrade.description, { factor: upgrade.bonusFactor, shop: $t(upgrade.shop) }) }}
                    </p>
                </div>
            </div>
            <div slot="footer" class="upgrade-status">
                <button type="button" class="btn btn-primary" v-if="!upgrade.isApplied"
                        :class="{'disabled': !upgrade.isAffordable()}" @click="applyUpgrade(upgrade)">
                    {{ $t('BUYFOR', { costs: tl(upgrade.costs) }) }}
                </button>
                <button type="button" class="btn btn-default disabled" v-if="upgrade.isApplied">
                    <i class="fa fa-check-circle"></i> <span class="applied-text">{{ 'UPGRADE_ALREADY_APPLIED' | translate }}</span>
                </button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import NiceAmount from '../filters/NiceAmount';
export default {
    name:     'upgrade',
    props:    ['upgrade'],
    data() {
        return {
            balance: this.$getBalance()
        };
    },
    methods:  {
        ...mapActions([
            'incrementAmount'
        ]),
        tl(val) {
            return NiceAmount(val);
        },
        applyUpgrade(upgrade) {
            this.$store.commit('APPLY_UPGRADE', { upgrade });
        }
    }
};
</script>

<style scoped lang="less">
.panel .icon i {
    display: flex;
    justify-content: center;
    align-items: center;
}
.icon img {
    max-width: 100%;
}
.icon-wrap {
    position: relative;
    .icon-overlay {
        position: absolute;
        top: 0;
        opacity: .8;
        width: 100%;
    }
}
</style>
